module.exports = __webpack_public_path__ + "static/media/owner.9453d40f.png";